// Import directly from the core implementation to avoid circular deps
import { defineStore } from 'pinia'
import { defaultParams } from '@/utils/constants'

export const useStoreLocatorStore = defineStore('storeLocator', {
  state: () => ({
    selectedStore: {},
    storeLocatorConfig: {},
    coordinates: {
      lat: undefined,
      lng: undefined,
    },
    defaultCoordinates: {
      lat: undefined,
      lng: undefined,
    },
    bounds: {
      Ha: undefined,
      Ua: undefined,
    },
    allStores: [],
    nearestStores: [],
    coreLibrary: null,
    mapsLibrary: null,
    geocodingLibrary: null,
    geometryLibrary: null,
    markerLibrary: null,
    error: {},
    resultsOffsetTop: null,
  }),

  actions: {
    // Error handling
    ADD_ERROR(error) {
      this.error = error
    },

    CLEAR_ERROR() {
      this.error = {}
    },

    // Configuration
    SET_STORE_LOCATOR_CONFIG(config) {
      this.storeLocatorConfig = config
    },

    // Coordinates
    SET_COORDINATES(coordinates) {
      this.coordinates = coordinates
    },

    SET_DEFAULT_COORDINATES(defaultCoordinates) {
      this.defaultCoordinates = defaultCoordinates
    },

    SET_BOUNDS(bounds) {
      this.bounds = bounds
    },

    // Google Maps libraries
    SET_CORE_LIBRARY(coreLibrary) {
      this.coreLibrary = coreLibrary
    },

    SET_MAPS_LIBRARY(mapsLibrary) {
      this.mapsLibrary = mapsLibrary
    },

    SET_GEOCODING_LIBRARY(geocodingLibrary) {
      this.geocodingLibrary = geocodingLibrary
    },

    SET_GEOMETRY_LIBRARY(geometryLibrary) {
      this.geometryLibrary = geometryLibrary
    },

    SET_MARKER_LIBRARY(markerLibrary) {
      this.markerLibrary = markerLibrary
    },

    // Stores
    SET_ALL_STORES(allStores) {
      this.allStores = allStores
    },

    SET_NEAREST_STORES(nearestStores) {
      this.nearestStores = nearestStores
    },

    SET_SELECTED_STORE(selectedStore) {
      this.selectedStore = selectedStore
    },

    SET_RESULTS_OFFSET_TOP(resultsOffsetTop) {
      this.resultsOffsetTop = resultsOffsetTop
    },

    // Main action to get store locator configuration
    async getStoreLocatorConfig(options = {}) {
      const { $axios = null } = options

      // Get axios from nuxt context if not provided
      const axiosInstance = $axios || (process.client && window.$nuxt ? window.$nuxt.$axios : null)

      if (!axiosInstance) {
        console.error('❌ No axios instance available')
        this.ADD_ERROR({ type: 'config', error: new Error('No axios instance') })
        return
      }

      try {
        const response = await axiosInstance.get('/configuration/store-locator', {
          params: defaultParams,
          useCache: true,
        })
        const { data } = response.data
        this.SET_STORE_LOCATOR_CONFIG(data)
      } catch (error) {
        this.ADD_ERROR({ type: 'config', error })
      }
    },
  },
})
